import { Toast, ToastSeverityEnum } from '@eih-netbroker/common';
import { CloseReason } from 'notistack';
import { useCallback } from 'react';
import { CloseSnackbarFn, SnackbarOptionsBase, useSnackbar } from '../../../context/SnackbarContext';
import { useNotification } from '../../../modules/message/services/useNotification';

export const useUserStreamToast = () => {
  const { showSuccess, showError, showInfo, showWarning } = useSnackbar();
  const { readMessageById } = useNotification();

  const mapping: Record<ToastSeverityEnum, (message: string, options?: SnackbarOptionsBase) => CloseSnackbarFn> = {
    ok: showSuccess,
    info: showInfo,
    warn: showWarning,
    error: showError,
  };

  const onClose = (messageId: number, reason: CloseReason) => {
    if (reason === 'instructed') {
      readMessageById(messageId);
    }
  };

  return useCallback((message: Toast) => {
    if (!message.severity) {
      message.severity = ToastSeverityEnum.Info;
    }

    if (message.body) {
      mapping[message.severity](message.body, {
        title: message.title,
        persist: message.sticky,
        onClose: reason => onClose(message.id, reason),
      });
    } else {
      mapping[message.severity](message.title, {
        persist: message.sticky,
        onClose: reason => onClose(message.id, reason),
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps -- the deps are not changing, no need to depend on them
  }, []);
};
